export const alturaContainer = 'calc(100% - 360px)';

export const anchoMax = {
  xs: '100%',
  sm: '600px',
  md: '900px',
  lg: '1200px',
  xl: '1536px',
};

export const anchoMaxForms = {
  xs: '300px',
  sm: '600px',
  md: '900px',
  lg: '1200px',
  xl: '1536px',
};

export const anchoMaxFormContacto = {
  xs: '300px',
  sm: '600px',
  md: '900px',
  lg: '1200px',
};

export const anchoMaxLogueado = {
  xs: '280px',
  sm: '580px',
  md: '880px',
  lg: '1180px',
  xl: '1516px',
};

export const anchoMaxLogueadoMenuAbierto = {
  xs: '280px',
  sm: '340px',
  md: '640px',
  lg: '940px',
  xl: '1296px',
};

export const anchoMaxListadosMenuAbierto = {
  xs: '100%',
  sm: '500px',
  md: '700px',
  lg: '950px',
  xl: '1300px',
};

export const anchoMaxListadosMenuCerrado = {
  xs: '100%',
  sm: '600px',
  md: '900px',
  lg: '1200px',
  xl: '1536px',
};

